import { render, staticRenderFns } from "./courseIntro.vue?vue&type=template&id=2aaf341c&scoped=true&"
import script from "./courseIntro.vue?vue&type=script&lang=js&"
export * from "./courseIntro.vue?vue&type=script&lang=js&"
import style0 from "./courseIntro.vue?vue&type=style&index=0&id=2aaf341c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aaf341c",
  null
  
)

export default component.exports